import { render, staticRenderFns } from "./Pokemon.vue?vue&type=template&id=959e9c82&"
import script from "./Pokemon.vue?vue&type=script&lang=js&"
export * from "./Pokemon.vue?vue&type=script&lang=js&"
import style0 from "./Pokemon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports